import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Typo from 'uikit/content/components/typo';
import { createIconComponent } from 'uikit/icons';

import styles from '../styles/uikitCardsCardMeta.module.scss';

const CardMeta = ({
  className = '',
  icon = '',
  modifier = 'uppercase',
  testId = '',
  text = '',
  variant = 's01',
}) => {
  const IconComponent = createIconComponent({ icon, size: 16, className: styles.icon });

  return (
    <div className={classnames(styles.element, className)}>
      {icon && IconComponent}
      <Typo data-testid={testId} element="span" variant={variant} modifier={modifier}>
        {text}
      </Typo>
    </div>
  );
};

CardMeta.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  testId: PropTypes.string,
  text: PropTypes.string,
  variant: PropTypes.string,
  modifier: PropTypes.string,
};

export default memo(CardMeta);
